'use client';

import { Player } from '@lottiefiles/react-lottie-player';

export default function Loading() {
  return (
    <div className="flex h-[calc(100vh-65px)] flex-col items-center justify-center md:h-[calc(100vh-80px)]">
      <Player
        autoplay
        loop
        src="https://lottie.host/0f4fe1f1-34dc-4654-b821-09a46f7ec42a/TNQAoKWIwD.json"
        style={{ height: '300px', width: '300px' }}
      ></Player>
      <p className="text-[18px] font-semibold text-[#888]">Now loading...</p>
    </div>
  );
}
